<template>
<div>
  <Popover open="false" class="relative" v-slot="{ open }">
    <!-- header -->
    <div class="bg-paficific-blue-50 text-white font-extrabold">
      <div class="bg-paficific-blue-100 items-center">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 container text-left p-1 flex">
          <svg  version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="15px" height="15px" viewBox="0 0 569.858 569.858" fill="white"
            xml:space="preserve">
          <g>
            <path d="M155.711,569.858h258.436c21.22,0,38.433-17.203,38.433-38.441V38.441C452.579,17.212,435.376,0,414.146,0H155.711
              c-21.238,0-38.432,17.212-38.432,38.441v492.976C117.289,552.655,134.473,569.858,155.711,569.858z M284.288,546.392
              c-13.378,0-24.203-10.815-24.203-24.184c0-13.359,10.825-24.184,24.203-24.184c13.33,0,24.184,10.824,24.184,24.184
              C308.481,535.576,297.618,546.392,284.288,546.392z M169.146,74.004c0-5.843,4.733-10.576,10.586-10.576h210.366
              c5.852,0,10.585,4.733,10.585,10.576v379.517c0,5.843-4.733,10.586-10.585,10.586H179.732c-5.853,0-10.586-4.743-10.586-10.586
              V74.004z"/>
            <path d="M223.997,364.273c2.046,6.024,8.865,10.911,15.233,10.911h90.892c6.369,0,13.264-4.857,15.415-10.844l4.38-12.23
              c2.151-5.986-1.263-10.844-7.631-10.844H227.697c-6.369,0-9.869,4.886-7.812,10.91L223.997,364.273z"/>
            <path d="M244.986,221.563h31.145v64.642l-11.322-14.037c-5.709-7.077-14.698-9.295-20.101-4.944
              c-5.384,4.341-5.135,13.607,0.574,20.684l29.845,37.016c1.071,1.329,2.266,2.458,3.519,3.424c2.209,2.897,5.651,4.781,9.562,4.781
              c2.974,0,5.67-1.119,7.774-2.907c2.323-1.205,4.552-2.993,6.406-5.308l29.845-37.016c5.709-7.077,5.967-16.343,0.574-20.694
              c-5.384-4.351-14.382-2.132-20.091,4.954l-12.432,15.405v-80.65c0-6.674-5.402-12.087-12.077-12.087
              c-0.335,0-0.66,0.067-0.994,0.096c-0.822-0.163-1.674-0.258-2.554-0.258h-39.675c-7.42,0-13.445,6.015-13.445,13.445
              C231.551,215.539,237.566,221.563,244.986,221.563z"/>
          </g>
          </svg>
          <small>{{$t('header.download.app')}}</small>
          <svg class="ml-2" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="15px" height="15px" 
              viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"
              fill="white"
              >
            <g>
              <g>
                <path d="M136,210c-24.814,0-45,20.186-45,45v122c0,24.814,20.186,45,45,45c24.814,0,45-20.186,45-45V255
                  C181,230.186,160.814,210,136,210z"/>
              </g>
            </g>
            <g>
              <g>
                <path d="M61,255c0-4.327,0.571-8.507,1.278-12.634C44.2,248.209,31,265.001,31,285v62c0,19.999,13.2,36.791,31.278,42.634
                  C61.571,385.507,61,381.327,61,377V255z"/>
              </g>
            </g>
            <g>
              <g>
                <path d="M376,210c-24.814,0-45,20.186-45,45v122c0,24.814,20.186,45,45,45c4.51,0,8.782-0.868,12.892-2.108
                  C383.308,438.401,366.305,452,346,452h-47.763c-6.213-17.422-22.707-30-42.237-30c-24.814,0-45,20.186-45,45
                  c0,24.814,20.186,45,45,45c19.53,0,36.024-12.578,42.237-30H346c41.353,0,75-33.647,75-75v-30V255
                  C421,230.186,400.814,210,376,210z"/>
              </g>
            </g>
            <g>
              <g>
                <path d="M449.722,242.366C450.429,246.493,451,250.673,451,255v122c0,4.327-0.571,8.507-1.278,12.634
                  C467.8,383.791,481,366.999,481,347v-62C481,265.001,467.8,248.209,449.722,242.366z"/>
              </g>
            </g>
            <g>
              <g>
                <path d="M256,0C131.928,0,31,100.928,31,225v0.383c8.937-6.766,19.277-11.717,30.687-13.934C68.698,110.251,153.054,30,256,30
                  s187.302,80.251,194.313,181.448c11.409,2.217,21.749,7.169,30.687,13.934V225C481,100.928,380.072,0,256,0z"/>
              </g>
            </g>
          </svg>
          <small class="pl-1">{{$t('header.help')}}</small>
        </div>
      </div>
      <div class="max-w-7xl mx-auto px-4 sm:px-6 container ">
        <div class="flex justify-between items-center py-4 md:justify-start md:space-x-10">
          <div class="flex-none">
            <a href="#" class="flex">
              <div class="flex-none pr-2">
                <img style="width:30px; height:30px" class="h-4 w-auto sm:h-10" src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg" alt="" />
              </div>
              <div class="flex-grow text-left items-center">
                {{$t('app.name')}}
              </div>
            </a>
          </div>
            <div class="flex-none">
              <PopoverButton :class="[open ? 'text-white-900' : 'text-white-500', 'group rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500']">
              <div class="flex-none pr-2 items-center ">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
              </div>
              <div class="flex-grow text-left items-center">
                  {{$t('category.title')}}
              </div>
            </PopoverButton>
            <transition enter-active-class="transition ease-out duration-200" 
            enter-from-class="opacity-0 translate-y-1" 
            enter-to-class="opacity-100 translate-y-0" 
            leave-active-class="transition ease-in duration-150" 
            leave-from-class="opacity-100 translate-y-0" 
            leave-to-class="opacity-0 translate-y-1">
              <PopoverPanel class="absolute z-10 -ml-4 mt-3 transform px-2 w-screen max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2">
                <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                  <div class="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 text-gray-500 text-left">
                    adad
                  </div>
                </div>
              </PopoverPanel>
            </transition>
          </div>

          <div class="pt-2 relative mx-auto text-gray-600 flex-grow flex">
            <input class="border-2 border-gray-300 bg-white h-10 px-5 flex-1 pr-16 rounded-lg text-sm focus:outline-none"
              type="search" name="search" placeholder="Search">
            <button type="submit" class="absolute right-0 top-0 mt-5 mr-4">
              <svg class="text-gray-600 h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 56.966 56.966;" xml:space="preserve"
                width="512px" height="512px">
                <path
                  d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
              </svg>
            </button>
          </div>
          <div class="flex-none">
            <a href="#" class="flex">
              <div class="flex-none pr-2 items-center ">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clip-rule="evenodd" />
                </svg>
              </div>
            </a>
          </div>
          <div class="flex-none">
              <a href="#" class="whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700">
              Sign up
            </a>
          </div>
          <div class="flex-none">
              <a href="#" class="whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700">
              Sign up
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- banner -->
    <div class="w-full bg-red-100 carousel-container" style="background-repeat: round; background-size: 100%;">
      <div class="pb-8 justify-center" style="background-color: rgba(255, 255, 255, 0.95);  -webkit-backdrop-filter: blur(3px); backdrop-filter: blur(30px); background-color: rgba(255, 255, 255, 0.5)">
        <div class="container">
          <div class="carousel js-flickity" data-flickity-options='{ "wrapAround": true, "autoPlay": true }'>
            <div class="carousel-cell">
              <img class="rounded-3xl" style="width:100%" src="https://www.static-src.com/siva/asset//05_2021/digital-alliance-desk.jpg?w=1680" alt="orange tree" />
            </div>
            <div class="carousel-cell">
              <img class="rounded-3xl" style="width:100%" src="https://www.static-src.com/siva/asset//05_2021/XIAOMI-BPD26-DESK.jpg?w=1680" alt="orange tree" />
            </div>
            <div class="carousel-cell">
              <img class="rounded-3xl"  style="width:100%" src="https://www.static-src.com/siva/asset//05_2021/rabcan26-desk.jpg?w=1680" alt="flight formation" />
            </div>
            <div class="carousel-cell">
              <img class="rounded-3xl"  style="width:100%" src="https://www.static-src.com/siva/asset//05_2021/WATCH26-DESK.jpg?w=1680" alt="flight formation" />
            </div>
            <div class="carousel-cell">
              <img class="rounded-3xl"  style="width:100%" src="https://www.static-src.com/siva/asset//05_2021/BPD26-LIFESTYLE-DESK.jpg?w=1680" alt="flight formation" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- content -->
    <div class="justify-center">
        <div class="container">
            <div class="transition-all ease-in-out duration-1000 flex flex-col justify-center ml-0 md:ml-2">
                  <div class="max-w-xs">
                      <div class="p-5 shadow-md m-2 mt-4">
                          <div class="text-xs font-bold uppercase text-teal-700 mt-1 mb-2">Blog post</div>
                          <div class="text-xl font-bold mb-2">Big case study</div>
                          <div class="truncate">Lorem ipsum dolor sit amet consectetur adipisicing elit. Id ut vel facilis iste, dicta est minus alias, aliquam, velit nisi quo assumenda porro dignissimos doloremque temporibus eum saepe aspernatur ab.</div>
                      </div>
                  </div>
              </div>
        </div>
    </div>

            
  </Popover>
</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Popover, PopoverButton, PopoverGroup, PopoverPanel } from '@headlessui/vue'
@Options({
  components: {
    Popover, PopoverButton, PopoverGroup, PopoverPanel
  }
})
export default class HelloWorld extends Vue {
  msg!: string
}
</script>
<style lang="less">


.carousel-cell {
  width: 100%;
  height: 200px;
  /* flex-box, center image in cell */
  display: -webkit-box;
  display: -webkit-flex;
  display:         flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-align-items: center;
          align-items: center;
}

.carousel-cell img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  /* dim unselected */
  opacity: 0.7;
  -webkit-transform: scale(0.85);
          transform: scale(0.85);
  -webkit-transition: opacity 0.3s, -webkit-transform 0.3s, transform 0.3s, -webkit-filter 0.3s, filter 0.3s;
          transition: opacity 0.3s, transform 0.3s, filter 0.3s;
}

/* brighten selected image */
.carousel-cell.is-selected img {
  opacity: 1;
  -webkit-transform: scale(1);
          transform: scale(1);
  -webkit-filter: none;
          filter: none;
}

@media screen and ( min-width: 768px ) {
  .carousel-cell {
    height: 400px;
  }
}

@media screen and ( min-width: 960px ) {
  .carousel-cell {
    width: 60%;
  }
}

/* buttons, no circle */
.flickity-prev-next-button {
  width: 60px;
  height: 60px;
  background: transparent;
  opacity: 0.6;
}
.flickity-prev-next-button:hover {
  background: transparent;
  opacity: 1;
}
/* arrow color */
.flickity-prev-next-button .arrow {
  fill: white;
}
.flickity-prev-next-button.no-svg {
  color: white;
}
/* closer to edge */
.flickity-prev-next-button.previous { left: 0; }
.flickity-prev-next-button.next { right: 0; }
/* hide disabled button */
.flickity-prev-next-button:disabled {
  display: none;
}
</style>